<template>
<div class="colorfilter_main">
Cor
<hr>
<div class="colorfilter">
	<Color v-for="m in colors" :key="m.ident" :info="m"/>
</div>
</div>
</template>

<script>
import Color from './Color.vue';

export default {
	name: 'ColorFilter',
	computed: {
		colors() {
			return this.$store.state.colors;
		}
	},
	components: { Color },
}
</script>

<style scoped>
div.colorfilter_main {
	margin-bottom: 2em;
}

div.colorfilter_main hr {
	margin-top: 0.5em ! important;
}

div.colorfilter {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	padding-left: 1em;
	padding-right: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/ColorFilter.vue